import { createContext } from 'react';

export interface Toast {
  id: string;
  title?: string;
  message?: string;
  variant?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  action?: React.ReactNode;
  allowMultiple?: boolean;
}

export interface ToastContextValue {
  showToast: (toast: Omit<Toast, 'id'>) => void;
  hideToast: (id: string) => void;
}

export const ToastContext = createContext<ToastContextValue | undefined>(undefined);
